module.exports = __webpack_public_path__ + "static/media/26_A.bbdae627.png";